module.exports = __webpack_public_path__ + "img/logo.d7edb8f7.png";